import PropTypes from 'prop-types';
import React from 'react';

import NotificationCell from './NotificationCell';
import InfiniteTable from '../common/InfiniteTable';
import {
  NoNotification,
  NoNotificationImage,
  NoNotificationText,
  styles,
} from './NotificationsTable.styled';
import * as TEXT from '../../../constants/texts';

import noNotificationsImage from '../../../../static/images/no-item/nonotifications1.png';

class NotificationsTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.loadNotifications = this.loadNotifications.bind(this);

    this.state = {
      initialLoadingDone: false,
      isFetching: false,
      settingRead: false,
    };
  }

  componentDidMount() {
    const { isFetching, initialLoadingDone } = this.state;
    if (!isFetching && !initialLoadingDone) {
      this.loadNotifications();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isFetching, initialLoadingDone, settingRead } = this.state;
    const { setRead } = this.props;
    const { notifications } = nextProps;
    if (!notifications.length && !isFetching && !initialLoadingDone) {
      this.loadNotifications();
      return;
    }

    const unread = notifications.filter((n) => !n.read);
    if (!settingRead && unread.length) {
      setRead(unread);
      this.setState({ settingRead: true });
    }
    if (settingRead && !unread.length) {
      this.setState({ settingRead: false });
    }
  }

  async loadNotifications() {
    const { initialLoadingDone } = this.state;
    const { shouldFetchMoreNotifications, getNotifications } = this.props;
    if (initialLoadingDone && !shouldFetchMoreNotifications) {
      return;
    }
    this.setState({ isFetching: true });
    this.setState({ initialLoadingDone: true });

    await getNotifications();
    this.setState({ isFetching: false });
  }

  render() {
    const { notifications, shouldFetchMoreNotifications } = this.props;
    const { isFetching, initialLoadingDone } = this.state;

    return (
      <InfiniteTable
        items={notifications}
        renderItem={({ createdAt, read, culprit, notification }) => (
          <NotificationCell
            time={createdAt}
            newBadge={!read}
            culprit={culprit}
            notification={notification}
          />
        )}
        keyExtractor={({ id }) => id}
        renderEmptyList={() => (
          <NoNotification>
            <NoNotificationImage
              src={noNotificationsImage}
              role="presentation"
              alt="no notification"
            />
            <NoNotificationText>{TEXT.NO_NOTIFICATIONS}</NoNotificationText>
          </NoNotification>
        )}
        resetScrollOnMount
        animateItems={{
          enter: 'fade',
          leave: 'none',
        }}
        loading={!initialLoadingDone || isFetching}
        hasNext={shouldFetchMoreNotifications}
        loadNext={this.loadNotifications}
        contentStyle={styles.table}
      />
    );
  }
}

NotificationsTable.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getNotifications: PropTypes.func.isRequired,
  setRead: PropTypes.func.isRequired,
  shouldFetchMoreNotifications: PropTypes.bool.isRequired,
};

NotificationsTable.defaultProps = {};

export default NotificationsTable;
